import { useState } from "react";

export type ToggleableProps = {
  visible: boolean,
  setVisible: (visible: boolean) => void,
  show: () => void,
  hide: () => void,
}

export function useToggleable(props: {
  visible: boolean,
  setVisible: (visible: boolean) => void,
}) : ToggleableProps {

  const _props = props as ToggleableProps;
  _props.show = () => props.setVisible(true);
  _props.hide = () => props.setVisible(false);

  return _props;
}

export function useStatefulToggleable(visible?: boolean) : ToggleableProps {
  const state = useState(visible || false);
  return useToggleable({ visible: state[0], setVisible: state[1]});
}